import React from 'react';
import HomePage from './HomePage';
import womanBalconyImg from '../assets/evan.png';
import cityMapMockup from '../assets/webp-mockups/city-map-upright.webp';
import nearHotelMockup from '../assets/webp-mockups/near-my-hotel-upright.webp';
import preferencesMockup from '../assets/webp-mockups/preferences-upright.webp';
import nearbyMockup from '../assets/webp-mockups/nearby-upright.webp';
import safeCityImg from '../assets/evan.png';
import evanImg from '../assets/evan.png';
import maleProfile2Img from '../assets/male-profile-2.png';
import sophieImg from '../assets/sophie.png';
import ambaUkImg from '../assets/amba-uk.png';

const airbnbSections = [
  {
    header: 'Increase bookings by up to 50%',
    subheader: "Enter your address and NearStay finds the best facilities near your property and ratings for all the vibes nearby.",
    image: womanBalconyImg,
    imageAlt: 'Traveler',
    mockup: preferencesMockup,
    mockupAlt: 'NearStay preferences',
    isImageLeft: true,
  },
  {
    header: 'Save Bookers Research Time',
    subheader: "Sign up and you'll get your own page with a QR code to screenshot and add . Potential bookers scan the QR and see how great the area is.",
    image: safeCityImg,
    imageAlt: 'Safe city',
    mockup: cityMapMockup,
    mockupAlt: 'NearStay city map',
    isImageLeft: false,
    mockupOffsetMore: true,
  },
  {
    header: 'Skyrocket Your Property Ratings',
    subheader: "Bookers rate an average 30% higher for Airbnb's when they find the best restaurants, nightlife and facilities nearby.",
    image: womanBalconyImg,
    imageAlt: 'Value',
    mockup: nearHotelMockup,
    mockupAlt: 'NearStay value areas',
    isImageLeft: true,
  },
];

const airbnbReviews = [
  {
    quote: 'My property got 30% higher ratings because my guests could find what they needed.',
    name: 'Amba',
    location: 'London, UK',
    avatar: ambaUkImg,
  },
  {
    quote: 'I got way more bookings after using this. Bookers wanted to make sure the area had what they need before booking.',
    name: 'Evan',
    location: 'Austin, TX',
    avatar: evanImg,
  },
  {
    quote: "I'd recommend this app. It helps my guests see the area easily.",
    name: 'Sophie',
    location: 'Seattle, Washington',
    avatar: sophieImg,
  },
  {
    quote: "Its much easier dealing with guests who already have an idea of what the area has for them. I'll keep using NearStay.",
    name: 'David',
    location: 'Denver, Colorado',
    avatar: maleProfile2Img,
  },
];

/**
 * /airbnbs — Airbnb host-focused landing, reusing the main layout.
 */
export default function AirbnbsPage() {
  React.useEffect(() => {
    document.title = 'NearStay For Airbnbs';
  }, []);

  return (
    <HomePage
      heroTitle="Show Potential Bookers How Great The Area Is"
      heroSubtitle="You could be missing out on 50% of bookings by not showing potential bookers your home's area on Airbnb."
      showCountdown={false}
      featureSectionsOverride={airbnbSections}
      headerCtaLabel="Sign Up Now"
      showHeaderTimer={false}
      heroCtaLabel="Increase My Bookings"
      sectionCtaLabel="Increase My Bookings"
      reviewsHeading="Here's What Other Property Owners Have Said"
      reviewsOverride={airbnbReviews}
    />
  );
}
